// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"397":"component---packages-gatsby-theme-garden-src-templates-local-file-js","532":"styles"}[chunkId] || chunkId) + "-" + {"15":"6e8c49d3dd0a90a0d370","397":"68550d032b6d73292ef6","532":"a38f4821ee0a262c1c84"}[chunkId] + ".js";
};